import type { ReactNode } from "react";

import { cn } from "./cn";

/** A list of facts: a term and its value in each row. The row has two columns when its box is wide enough, one when it is not. */
export function Facts({
  children,
  className,
}: Readonly<{ children: ReactNode; className?: string }>) {
  return <dl className={cn("m-0 grid gap-2.5 @container", className)}>{children}</dl>;
}

export function Fact({ term, children }: Readonly<{ term: string; children: ReactNode }>) {
  return (
    <div className="grid gap-0.5 text-sm @sm:grid-cols-[minmax(7.5rem,1fr)_minmax(0,2fr)] @sm:gap-3">
      <dt className="text-muted-foreground">{term}</dt>
      <dd className="m-0 break-words">{children}</dd>
    </div>
  );
}
